import React from "react";
import { Link } from "react-router-dom";
import "../css-coding/ContinueReading.css"; // Custom styles
import articleI1 from '../assets/Article_img_1.png';
import articleI2 from '../assets/Article_img _2.png';
import articleI3 from '../assets/Article_img_3.png';

const ContinueReading = ({ currentArticle }) => {
  // Filter out the current article (optional logic)
  const articles = [
    {
      id: "/article1",
      image: articleI2,
      title: "Why Personal Branding Is Important in 2025 (And How It Can Grow Your Business)",
      date: "Jan 1, 2026",
      
    },
    {
      id: "/article2",
      image: articleI1,
      title: "5 Best Video Editing Software in 2025 (And How to Choose the Right One for Your Success)",
      date: "Jan 2, 2026",
     
    },
    {
      id: "/article3",
      image: articleI3,
      title: "How to Earn ₹1 Lakh Per Month as a Video Editor in 2025",
      date: "Jan 3, 2026",
      
    },
  ].filter((article) => article.id !== currentArticle);

  return (
    <div className="continue-reading-container">
      <div className="continue-reading-header">
        <div>
          <h2>Continue Reading</h2>
          <p>The latest handpicked blog articles</p>
        </div>
        <Link to="/blog" className="check-all-link">
          Check all blogs →
        </Link>
      </div>

      <div className="article-cards">
        {articles.map((article) => (
          <Link to={article.id} className="article-card" key={article.id}>
            <div className="article-image-wrapper">
              <img src={article.image} alt={article.title} />
             
            </div>
            <div className="article-details-cr">
              <h3>{article.title}</h3>
              <p className="date">{article.date}</p>
              <p className="read-more-art">Read more →</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ContinueReading;

